import type { HttpClient } from '@/lib/http/client.js'
import type { CreateRoleInput, Role, UpdateRoleInput } from '@/types/role/role.type.js'

/** `admin/roles`, verified against `role.controller.ts`. Unpaginated. */
export interface RoleService {
  list: () => Promise<readonly Role[]>
  get: (id: string) => Promise<Role>
  create: (input: CreateRoleInput) => Promise<Role>
  update: (id: string, input: UpdateRoleInput) => Promise<Role>
  /** PUT — replaces the whole set. Refused for a system role. */
  setPermissions: (id: string, permissions: readonly string[]) => Promise<Role>
  /** 204. Refused for a system role. */
  remove: (id: string) => Promise<void>
}

export function createRoleService(http: HttpClient): RoleService {
  return {
    list: () => http.get<readonly Role[]>('admin/roles'),
    get: (id) => http.get<Role>(`admin/roles/${encodeURIComponent(id)}`),
    create: (input) => http.post<Role>('admin/roles', input),
    update: (id, input) => http.patch<Role>(`admin/roles/${encodeURIComponent(id)}`, input),
    setPermissions: (id, permissions) =>
      http.put<Role>(`admin/roles/${encodeURIComponent(id)}/permissions`, { permissions }),
    remove: async (id) => {
      await http.delete(`admin/roles/${encodeURIComponent(id)}`)
    },
  }
}
